import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ 
        textAlign: 'center', 
        color: '#2c3e50',
        marginBottom: '30px',
        fontSize: '28px'
      }}>
        プライバシーポリシー
      </h1>

      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
          STYLE株式会社（以下「当社」といいます）は、当社が提供する出会い系サービス「START」
          （以下「本サービス」といいます）において、お客様の個人情報の保護を最重要事項と考えております。
        </p>
        <p style={{ fontSize: '16px' }}>
          このプライバシーポリシーは、当社が収集・利用・管理する個人情報の取り扱いについて定めるものです。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          1. 個人情報の定義
        </h3>
        <p style={{ marginBottom: '15px' }}>
          本プライバシーポリシーにおいて「個人情報」とは、個人情報の保護に関する法律（以下「個人情報保護法」といいます）第2条第1項に定義される個人情報を指します。
        </p>
        <p>
          具体的には、氏名、生年月日、住所、電話番号、メールアドレス、その他の当該個人を識別することができる情報を指します。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          2. 個人情報の収集
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            収集する個人情報
          </h4>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li style={{ marginBottom: '8px' }}>氏名</li>
            <li style={{ marginBottom: '8px' }}>生年月日</li>
            <li style={{ marginBottom: '8px' }}>メールアドレス</li>
            <li style={{ marginBottom: '8px' }}>電話番号</li>
            <li style={{ marginBottom: '8px' }}>住所</li>
            <li style={{ marginBottom: '8px' }}>職業</li>
            <li style={{ marginBottom: '8px' }}>年収</li>
            <li style={{ marginBottom: '8px' }}>プロフィール写真</li>
            <li style={{ marginBottom: '8px' }}>身分証明書（年齢認証用）</li>
          </ul>

          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            収集方法
          </h4>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>お客様からの直接入力</li>
            <li style={{ marginBottom: '8px' }}>お客様からのアップロード</li>
            <li style={{ marginBottom: '8px' }}>お客様とのメール・電話でのやり取り</li>
            <li style={{ marginBottom: '8px' }}>当社ウェブサイトの利用履歴</li>
          </ul>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          3. 個人情報の利用目的
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            当社は、収集した個人情報を以下の目的で利用いたします：
          </p>
          <ol style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>本サービスの提供</strong><br />
              マッチング機能、メッセージ機能、掲示板機能等の提供
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>年齢認証・本人確認</strong><br />
              法令に基づく年齢確認および本人確認の実施
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>お客様サポート</strong><br />
              お問い合わせへの対応、技術的サポートの提供
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>サービス改善</strong><br />
              利用状況の分析、サービス品質の向上
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>不正利用の防止</strong><br />
              詐欺行為、なりすまし等の不正利用の防止
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>法令遵守</strong><br />
              関連法令の遵守、行政機関からの照会への対応
            </li>
          </ol>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          4. 個人情報の管理
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            安全管理措置
          </h4>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li style={{ marginBottom: '8px' }}>SSL暗号化通信の採用</li>
            <li style={{ marginBottom: '8px' }}>アクセス制御の実施</li>
            <li style={{ marginBottom: '8px' }}>ウイルス対策ソフトの導入</li>
            <li style={{ marginBottom: '8px' }}>定期的なセキュリティ監査の実施</li>
            <li style={{ marginBottom: '8px' }}>従業員への個人情報保護教育の実施</li>
          </ul>

          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            保存期間
          </h4>
          <p style={{ marginBottom: '10px' }}>
            個人情報は、利用目的の達成に必要な期間を超えて保存いたしません。
            ただし、法令により保存期間が定められている場合は、その期間保存いたします。
          </p>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '5px' }}>アカウント情報：サービス利用終了後1年間</li>
            <li style={{ marginBottom: '5px' }}>身分証明書：年齢認証完了後24時間以内に削除</li>
            <li style={{ marginBottom: '5px' }}>利用履歴：サービス利用終了後3年間</li>
          </ul>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          5. 個人情報の第三者提供
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            当社は、以下の場合を除き、お客様の個人情報を第三者に提供いたしません：
          </p>
          <ol style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>
              お客様の事前の同意がある場合
            </li>
            <li style={{ marginBottom: '10px' }}>
              法令に基づく場合
            </li>
            <li style={{ marginBottom: '10px' }}>
              人の生命、身体または財産の保護のために必要な場合
            </li>
            <li style={{ marginBottom: '10px' }}>
              公衆衛生の向上または児童の健全な育成の推進のために特に必要な場合
            </li>
            <li style={{ marginBottom: '10px' }}>
              国の機関、地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合
            </li>
          </ol>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          6. 個人情報の委託
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            当社は、本サービスの提供に必要な範囲内で、個人情報の取り扱いを委託する場合があります。
            委託先は、当社が適切な安全管理措置を講じていることを確認し、委託契約において個人情報の適切な取り扱いを義務付けております。
          </p>
          <p>
            委託先での個人情報の取り扱いについては、当社が責任を負います。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          7. 個人情報の開示・訂正・利用停止
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            お客様は、当社が保有するお客様の個人情報について、以下の請求をすることができます：
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li style={{ marginBottom: '8px' }}>個人情報の開示</li>
            <li style={{ marginBottom: '8px' }}>個人情報の訂正・追加・削除</li>
            <li style={{ marginBottom: '8px' }}>個人情報の利用停止・消去</li>
            <li style={{ marginBottom: '8px' }}>個人情報の第三者提供の停止</li>
          </ul>
          <p style={{ marginBottom: '10px' }}>
            これらの請求については、以下の方法でお申し込みください：
          </p>
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '15px',
            borderRadius: '6px',
            border: '1px solid #e9ecef'
          }}>
            <p style={{ marginBottom: '5px' }}>
              <strong>メール：</strong>nwo123123@yahoo.co.jp
            </p>
            <p style={{ marginBottom: '5px' }}>
              <strong>電話：</strong>03-6416-5484
            </p>
            <p>
              <strong>受付時間：</strong>平日 9:00〜18:00
            </p>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          8. クッキー（Cookie）の使用
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            当社は、お客様により良いサービスを提供するため、クッキーを使用することがあります。
            クッキーは、お客様のブラウザに送信され、お客様のコンピュータに保存されます。
          </p>
          <p style={{ marginBottom: '15px' }}>
            クッキーの使用目的：
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li style={{ marginBottom: '5px' }}>ログイン状態の維持</li>
            <li style={{ marginBottom: '5px' }}>利用状況の分析</li>
            <li style={{ marginBottom: '5px' }}>サービス品質の向上</li>
          </ul>
          <p>
            お客様は、ブラウザの設定によりクッキーの使用を拒否することができます。
            ただし、その場合、本サービスの一部機能が正常に動作しない可能性があります。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          9. アクセス解析ツールの使用
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            当社は、Google Analytics等のアクセス解析ツールを使用して、お客様の利用状況を分析しています。
            これらのツールは、お客様の個人を特定する情報を収集することはありません。
          </p>
          <p>
            アクセス解析ツールの利用により収集された情報は、当社のサービス改善目的でのみ使用されます。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          10. 未成年者の個人情報
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            本サービスは、18歳以上の方のみご利用いただけます。
            未成年者の方からの個人情報の提供は、保護者の同意を得た場合を除き、お断りしております。
          </p>
          <p>
            未成年者の方から個人情報が提供された場合、当社は適切な措置を講じます。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          11. プライバシーポリシーの変更
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            当社は、必要に応じて本プライバシーポリシーを変更することがあります。
            重要な変更がある場合は、当社ウェブサイト上でお知らせいたします。
          </p>
          <p>
            変更後のプライバシーポリシーは、当社ウェブサイト上に掲載された時点から効力を生じます。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          12. お問い合わせ
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '15px' }}>
            本プライバシーポリシーに関するお問い合わせは、以下の方法でお願いいたします：
          </p>
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '15px',
            borderRadius: '6px',
            border: '1px solid #e9ecef'
          }}>
            <p style={{ marginBottom: '5px' }}>
              <strong>STYLE株式会社</strong>
            </p>
            <p style={{ marginBottom: '5px' }}>
              <strong>個人情報保護責任者：</strong>運営責任者 橋田 信介
            </p>
            <p style={{ marginBottom: '5px' }}>
              <strong>メール：</strong>nwo123123@yahoo.co.jp
            </p>
            <p style={{ marginBottom: '5px' }}>
              <strong>電話：</strong>03-6416-5484
            </p>
            <p>
              <strong>受付時間：</strong>平日 9:00〜18:00
            </p>
          </div>
        </div>
      </div>

      <div style={{
        backgroundColor: '#d4edda',
        padding: '20px',
        borderRadius: '6px',
        border: '1px solid #c3e6cb',
        color: '#155724',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '15px' }}>お問い合わせ</h3>
        <p style={{ marginBottom: '10px' }}>
          プライバシーポリシーについてご不明な点がございましたら、お気軽にお問い合わせください。
        </p>
        <p style={{ fontWeight: 'bold' }}>
          お問い合わせ先：nwo123123@yahoo.co.jp
        </p>
        <p style={{ fontSize: '14px', marginTop: '15px' }}>
          {/* 制定日：2025年7月24日 */}
          <br/>
          最終更新日：2025年8月20日
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 